import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const WarningModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background: ${COLORS.surface};
  border-radius: ${RADII.popup};
`

export const WarningContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 410px;
`

export const WarningTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 17px;
  text-align: center;
  color: ${COLORS.secondaryExtraDark};
  margin: 0;
`

export const WarningBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  background: rgba(231, 158, 0, 0.16);
  border: 1px solid ${COLORS.warning};
  border-radius: ${RADII.field};
`

export const WarningText = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: ${COLORS.secondaryExtraDark};

  strong {
    font-weight: 700;
  }
`

export const WarningButtonContainer = styled.div`
  display: flex;
  gap: 80px;
`
